import { useEffect, useState } from 'react'
import { useForm } from 'react-hook-form'
import { zodResolver } from '@hookform/resolvers/zod'
import { z } from 'zod'
import { apiPatch, apiPost } from '../../../util/api'

const useSavedRecruitersForm = (
  savedRecruiter,
  addContact = false,
  setOtherSavedRecruiters,
) => {
  const id = savedRecruiter.id

  const [buttonStatus, setButtonStatus] = useState('save')
  const [resumeName, setResumeName] = useState(savedRecruiter.resume)
  const [resumeUrl, setResumeUrl] = useState(savedRecruiter.resume_url)
  const [showResumeFileName, setShowResumeFileName] = useState(false)
  const [showAddDialog, setShowAddDialog] = useState(false)
  const toggleShowAddReminderDialog = () => setShowAddDialog(!showAddDialog)

  const schema = z.object({
    firm_name: z.string().optional(),
    email: z.string().email().optional(),
    phone: z.string().optional(),
    website: z.string().optional(),
    recruiter_name: z.string().optional(),
    follow_up: z.union([z.date(), z.null(), z.string()]).optional(),
    notes: z.string().optional(),
    resume: z
      .union([z.instanceof(File), z.null(), z.string()])
      .optional()
      .refine((file) => !file || file?.size < 5000000 || !!resumeUrl, {
        message: 'Resume file must be less than 5MB',
      }),
  })

  const regularValues = {
    firm_name: savedRecruiter.firm_name,
    email: savedRecruiter.email,
    phone: savedRecruiter.phone,
    website: savedRecruiter.website,
    recruiter_name: savedRecruiter.recruiter_name,
    follow_up: savedRecruiter.follow_up_date,
    notes: savedRecruiter.notes || '',
    resume: savedRecruiter.resume,
  }

  const addContactValues = {
    recruiter_name: '',
    email: '',
    phone: '',
    firm_name: savedRecruiter.firm_name,
  }

  const defaultValues = addContact ? addContactValues : regularValues

  const form = useForm({
    resolver: zodResolver(schema),
    defaultValues,
  })

  const uploadedResume = form.watch('resume')

  useEffect(() => {
    if (uploadedResume?.name) setShowResumeFileName(true)
  }, [uploadedResume])

  const onSubmit = async (values) => {
    setButtonStatus('saving')

    const url = addContact
      ? `/job-search/recruiters/my_recruiters`
      : `/job-search/recruiters/my_recruiters/${id}`

    const data = {
      saved_recruiter: {
        firm_name: values.firm_name,
        email: values.email,
        phone: values.phone,
        website: values.website,
        recruiter_name: values.recruiter_name,
        follow_up_date: values.follow_up,
        notes: values.notes,
        resume: values.resume,
        recruiter_estab_id: savedRecruiter.recruiter_estab_id,
      },
    }
    const response = addContact
      ? await apiPost(url, data, true)
      : await apiPatch(url, data, true)

    if (response.status === 200 || response.status === 201) {
      if (addContact) {
        toggleShowAddReminderDialog()
        setOtherSavedRecruiters((prev) => [
          ...prev,
          response.data.saved_recruiter,
        ])
      }
      setResumeName(response.data.saved_recruiter.resume)
      setResumeUrl(response.data.saved_recruiter.resume_url)
      setButtonStatus('saved')
      setShowResumeFileName(false)
      setTimeout(() => {
        setButtonStatus('save')
      }, 2000)
      return response
    } else {
      console.log(response)
      throw new Error('Failed to save recruiter')
    }
  }
  return {
    form,
    onSubmit,
    buttonStatus,
    resumeName,
    resumeUrl,
    showResumeFileName,
    showAddDialog,
    toggleShowAddReminderDialog,
  }
}

export default useSavedRecruitersForm
